const APIHOST = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api2" : "https://www.christmaslistapp.com/api2";


function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

export function claimItem(itemID, userID, token) {
    console.log('CLAIMING ITEM...', itemID);
    return fetch(APIHOST + "/shoppinglist", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify({
                itemID: itemID,
                userID: userID
            }) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

export function unClaimItem(itemID, token) {
    console.log('UNCLAIMING ITEM...', itemID);
    return fetch(APIHOST + "/shoppinglist/" + itemID, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE', 
            body: ''
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

export function updateShoppingItem(itemData, token) {
    console.log('UPDATING SHOPPING ITEM...', itemData);
    return fetch(APIHOST + "/shoppinglist", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(itemData) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}